"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
exports.default = `<svg id="machine-icon-cmm" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 540 540">
  <path fill="#F93" d="M270 194l-23 13v42l214 124 23-13v-42z" />
  <path fill="#333" d="M259 209l13-8 203 116-14 8z" />
  <path fill="#999" d="M270 264l-146 84v108l146 84 146-84V348z" />
  <path fill="#4D4D4D" d="M247 221L56 331v29l214 123 191-110v-29z" />
  <path fill="#D8D8D8" d="M134 343l-23 13v7l41 24 23-14v-6z" />
  <path fill="#D8D8D8" d="M143 223l13 7v131l-13 8-14-8V230zM340 106l13 7v135l-13 7-14-7V113z" />
  <path fill="#D8D8D8" d="M334 54L120 177v48l27 16 214-124V69z" />
  <path fill="#333" d="M147 233l198-114V86L147 201z" />
  <path fill="#E6E6E6" d="M228 250h2l11 18v2h-2l-11-19v-1z" />
  <ellipse cx="241" cy="271" fill="#D12B36" rx="6" ry="6" transform="rotate(-31 241 271)" />
  <path fill="#565656" d="M222 201v13l2 25c2 4 5 7 8 9 5 3 10 0 10-7v-12l-10-6h-1l-9-22zm-6 31l10 6v12c0 7-4 10-10 7-5-3-10-11-10-18v-13l10 6zm0 0l7 4v21c-2 2-4 2-7 0-5-3-10-11-10-18v-13l10 6zm-10-30l1 2 14 8h6l14-8 1-2v26l-1 2-14 8h-6l-14-8-1-2v-26zm0 0l1 2 14 8h2v26h-2l-14-8-1-2v-26zm21 10h-6l-14-8v-3l14-8h6l14 7v4l-14 8z" />
  <path fill="#1A1A1A" d="M236 246c3 0 3-4 3-5v-11l-8-4h-1v-1l-5-19v7c0 6 4 29 8 32l3 1z" />
  <path fill="#333" d="M237 246l-15 8-8-14 15-9z" />
  <path fill="#333" d="M233 232c3 1 6 6 6 10s-3 5-6 3-6-6-6-10 3-5 6-3zm-14 8c3 2 5 6 5 10s-2 5-5 4-6-7-6-11c0-3 2-5 6-3z" />
  <path fill="#F93" d="M226 3l-24 15-17 177 45 26 25-14V20z" />
  <path fill="#CCC" d="M191 136l-71 41v48l27 16 71-41v-48z" />
  <path fill="#333" d="M147 233l71-40v-33l-71 41z" />
  <path fill="#F93" d="M136 168l-16 9v48l27 15 16-9v-48zM345 126V79l-27-16 16-9 27 15v48l-16 9" />
</svg>`;
//# sourceMappingURL=machine-icon-cmm.js.map